"use client";
import React from 'react'

export default function Loading() {
  return (
    <div className="min-height-[100vh]"></div>
  )
}
